require('./accueil-interface-3.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import cloneDeep from 'lodash/cloneDeep';

export default class AccueilInterface3Component {
  constructor() {
    this.controller = AccueilInterface3Controller;
    this.template = require('./accueil-interface-3.html');
  }
}

// @ngInject
class AccueilInterface3Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ACCUEIL_INTERFACE_3));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: this.prepareAfterGet(state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.asMutable({deep: true}) : this.data),
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  prepareAfterGet(data) {
    const res = cloneDeep(data);
    return res;
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface3(this.data, true));
  }
  nextStep() {
    this.$ngRedux.dispatch(DemandeActions.updateAccueilInterface3(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/accueil-interface-3/accueil-interface-3.component.js